module.exports = __webpack_public_path__ + "static/media/1A.9ad02533.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/1A.pdf
// module id = 77
// module chunks = 0